__turbopack_context__.v({
  "Pink": "navigation-module-scss-module__YXnBPa__Pink",
  "container": "navigation-module-scss-module__YXnBPa__container",
  "hiding": "navigation-module-scss-module__YXnBPa__hiding",
  "horizontal": "navigation-module-scss-module__YXnBPa__horizontal",
  "li": "navigation-module-scss-module__YXnBPa__li",
  "link": "navigation-module-scss-module__YXnBPa__link",
  "list": "navigation-module-scss-module__YXnBPa__list",
  "logo": "navigation-module-scss-module__YXnBPa__logo",
  "main": "navigation-module-scss-module__YXnBPa__main",
  "main_nav": "navigation-module-scss-module__YXnBPa__main_nav",
  "mobileOnly": "navigation-module-scss-module__YXnBPa__mobileOnly",
  "nav": "navigation-module-scss-module__YXnBPa__nav",
  "oaf": "navigation-module-scss-module__YXnBPa__oaf",
  "overlay": "navigation-module-scss-module__YXnBPa__overlay",
  "overlayContainer": "navigation-module-scss-module__YXnBPa__overlayContainer",
  "sub_nav": "navigation-module-scss-module__YXnBPa__sub_nav",
  "toggle": "navigation-module-scss-module__YXnBPa__toggle",
  "vertical": "navigation-module-scss-module__YXnBPa__vertical",
  "visible": "navigation-module-scss-module__YXnBPa__visible",
  "wrapper": "navigation-module-scss-module__YXnBPa__wrapper",
});
